module.exports = __webpack_public_path__ + "img/cover-minigame-bg.b678d9d4.jpg";